import { iconBukaohe, iconKaohe } from "@/assets/image/icon-set/index.js";
import List from "@/components/list";
import router from "@/router";
import store from "@/store";
import "../user/table.scss";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const toPermissionTransfer = listeners["permission-transfer"] || function() {};
  const showPermissionDia = listeners["showPermissionDia"] || function() {};
  const flatPermissions = store.getters.flatPermissions;

  const permissionList = [
    "user:permission",
    "permissionMove:save",
    "permissionMove:notesPage",
  ];

  const Deal = ({ props: { vo } }) => {
    const user = vo.row;
    const dealConf = [];
    
    dealConf.push([
      "icon-permission",
      "权限设置",
      () => {
        showPermissionDia(user);
      },
      "user:permission",
    ]);
    dealConf.push([
      "icon-diaodong",
      "权限转让申请",
      () => {
        toPermissionTransfer(user);
      },
      "permissionMove:save",
    ]);
    dealConf.push([
      "icon-audit-detail",
      "审核记录",
      () => {
        router.push({
          path: "/liaison/auditDetail",
          query: { id: user.uuid },
        });
      },
      "permissionMove:notesPage",
    ]);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const NameColumn = ({ props: { vo } }) => {
    const item = vo.row;
    let flag = item.isExamName === "是";
    return (
      <div>
        <div>
          <span
            class="blue_char"
            onClick={() => {
              router.push({
                path: "/user/detail",
                query: { id: item.uuid, status: true },
              });
            }}
          >
            {item.userName}
          </span>
          <img class="audit_img" src={flag ? iconKaohe : iconBukaohe} alt="" />
        </div>
        <div class="coll_char">
          {item.topDeptName}/{item.leaderTypeName}
        </div>
      </div>
    );
  };

  const UserDeptRoleList = ({ props: { vo } }) => {
    const roleList = vo.row.userDeptRoleList;
    return (
      <div class='role_style'>
        {roleList.map((item, i) => (
          i < 3 ? (
            i < 2 && i < roleList.length -1 ?
            <span>
              {item}；<br/>
            </span>
          : <span>{item}</span>) : null
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      width: "170",
      render: (vo) => <NameColumn vo={vo} />,
    },
    {
      label: "手机号",
      prop: "userMobile",
      minWidth: "100",
    },
    {
      label: "所在单位",
      prop: "deptName",
      minWidth: "120",
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "220",
    },
    {
      label: "角色权限",
      prop: "userDeptRoleList",
      width: "260",
      render: (vo) => <UserDeptRoleList vo={vo} />,
    },
  ];

  let iconNum = 0;
  permissionList.forEach((x) => {
    if (flatPermissions.includes(x)) {
      iconNum += 1;
    }
  });
  if (iconNum > 0) {
    AccountTableConfig.push({
      label: "操作",
      fixed: "right",
      width: String(iconNum * 30 + 10 > 100 ? 100 : iconNum * 30 + 10),
      render: (vo) => <Deal vo={vo} />,
    });
  }

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
